/** Dedicated mobile routes under My Feed Active */
export const MY_FEED_ACTIVE_SUB_ROUTES = [
    '/feed/my-feed-active/feed-1',
    '/feed/my-feed-active/feed-2',
    '/feed/my-feed-active/feed-3',
    '/feed/my-feed-active/feed-4',
    '/feed/my-feed-active/feed-5',
    '/feed/my-feed-active/pocket-feed',
];

export function isMyFeedActiveSubRoute(pathname) {
    return MY_FEED_ACTIVE_SUB_ROUTES.includes(pathname);
}

/** State to attach when opening a Feed 1–5 / Pocket tab from My Feed Active */
export function buildMyFeedActiveSubRouteState(activeItem, parentReturnTo) {
    return {
        activeItem,
        returnTo: {
            path: '/feed/my-feed-active',
            state: {
                returnTo: parentReturnTo ?? {
                    path: '/feed',
                    state: {},
                },
            },
        },
    };
}

/** Back from Feed1–5 / PocketFeed mobile header */
export function navigateFromFeedActiveSubPage(navigate, location) {
    const returnTo = location.state?.returnTo;
    if (returnTo?.path) {
        navigate(returnTo.path, { replace: true, state: returnTo.state ?? {} });
        return;
    }
    navigate('/feed/my-feed-active', { replace: true });
}

/** Back from My Feed Active shell (sidebar hub on mobile) */
export function navigateFromMyFeedActiveHub(navigate, location) {
    const returnTo = location.state?.returnTo;
    if (returnTo?.path) {
        navigate(returnTo.path, { replace: true, state: returnTo.state ?? {} });
        return;
    }
    navigate('/feed', { replace: true, state: {} });
}

/** Portfolio details opened from Feed 1–5 / Pocket (preserve feed page + back chain) */
export function buildPortfolioDetailsStateFromFeedPage(location, detailsState = {}, scrollPosition) {
    const feedPageState = { ...(location.state ?? {}) };
    if (scrollPosition != null && Number.isFinite(Number(scrollPosition))) {
        feedPageState.scrollPosition = Number(scrollPosition);
    }
    return {
        ...detailsState,
        from: 'feed-active',
        returnTo: {
            path: location.pathname,
            state: feedPageState,
        },
    };
}

/** Open portfolio details from a feed listing card (saves grid scroll first). */
export function navigateToPortfolioFromFeedPage(navigate, location, captureScrollTop, detailsState = {}) {
    const scrollPosition = captureScrollTop();
    navigate('/portfolio-details', {
        state: buildPortfolioDetailsStateFromFeedPage(location, detailsState, scrollPosition),
    });
}
